






































import { Vue, Component, Prop } from "vue-property-decorator"
import { fetchAll } from "@/api/refund-money-request"
import { IPaginatedCollection, IPaginationRequest } from "@/api/types"
import ListItemsView from "@/components/ListItemsView.vue"
import { StatusLabels } from './helper'
import { debounce } from "typescript-debounce-decorator"
import {IRefundMoneyRequest} from "@/types/refundMoneyRequest";

@Component({
  components: { ListItemsView }
})
export default class List extends Vue {
  protected statusLabels = StatusLabels

  protected headers = [
    { text: "Id транзакции", value: "transactionId" },
    { text: "Дата создания", value: "createdAt" },
    { text: "Номер полиса", value: "policyNumber" },
    { text: "Плановая дата возврата", value: "willBeRefundedOn" },
    { text: "Статус", value: "status" },
    { text: "Сумма возврата, руб.", value: "amountRefunded" },
    { text: "", value: "action", width: 50 }
  ]

  protected inProcess = false

  protected result: IPaginatedCollection<IRefundMoneyRequest> = {
    page: 1,
    limit: 20,
    totalItems: 0,
    data: []
  }

  created() {
    this.fetch(1)
  }

  @debounce(1000, { leading: false })
  searchChanged () {
    this.fetch(1)
  }

  limitChanged (limit: number) {
    this.result.limit = limit
    this.fetch(1)
  }

  async fetch (page: number = 1) {
    if (this.inProcess) return
    this.inProcess = true
    this.result.page = page
    try {
      this.result = await fetchAll({
        page: this.result.page,
        limit: this.result.limit,
      } as IPaginationRequest)
      this.inProcess = false
    } catch (e) {
      this.inProcess = false
    }
  }
}
